class ScrollToTop extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.scrollThreshold = parseInt(this.dataset.scrollThreshold) || 80;
    this.isVisible = false;
    this.observer = null;
    this.sentinelElement = null;
  }

  connectedCallback() {
    this.button = this.querySelector('.scroll-to-top-button');

    this.setupSentinel();
    this.setupIntersectionObserver();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.sentinelElement && this.sentinelElement.parentNode) {
      this.sentinelElement.parentNode.removeChild(this.sentinelElement);
    }
  }

  setupSentinel() {
    this.sentinelElement = document.createElement('div');
    this.sentinelElement.style.position = 'absolute';
    this.sentinelElement.style.top = this.scrollThreshold + '%';
    this.sentinelElement.style.height = '1px';
    this.sentinelElement.style.width = '1px';
    this.sentinelElement.style.display = 'block';
    this.sentinelElement.classList.add('btt-sentinal');
    this.sentinelElement.style.opacity = '0';
    this.sentinelElement.style.pointerEvents = 'none';
    document.body.appendChild(this.sentinelElement);
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && !this.isVisible) {
          this.showButton();
        } else if (entry.isIntersecting && this.isVisible) {
          this.hideButton();
        }
      });
    }, options);

    this.observer.observe(this.sentinelElement);
  }

  setupEventListeners() {
    this.button.addEventListener('click', () => {
      this.scrollToTop();
    });
  }

  showButton() {
    this.isVisible = true;
    this.classList.add('visible');
    document.body.classList.add('sticky-atc-visible');
  }

  hideButton() {
    this.isVisible = false;
    this.classList.remove('visible');
    document.body.classList.remove('sticky-atc-visible');
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
if (!customElements.get('scroll-to-top')) {
  customElements.define('scroll-to-top', ScrollToTop);
}

if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyATC extends ScrollToTop {
      constructor() {
        super();
        this.title_el = this.querySelector('.sticky-atc__title');
        this.sticky_btn = this.querySelector('[data-sticky-submit]');

        if (!this.title_el) return;

        document.body.addEventListener(
          'variantChange',
          this.setupVariantChangeListener.bind(this),
        );

        if (this.sticky_btn) {
          this._mainBtn = document.getElementById('main_atc_button');
          this._spinner = this.sticky_btn.querySelector(
            '.loading-overlay__spinner',
          );

          this.sticky_btn.addEventListener('click', () => {
            if (this.sticky_btn.getAttribute('aria-disabled') === 'true')
              return;
            this._mainBtn?.click();
          });
          this._syncBtn();

          if (this._mainBtn) {
            this._btnObserver = new MutationObserver(() => this._syncLoading());
            this._btnObserver.observe(this._mainBtn, {
              attributes: true,
              attributeFilter: ['aria-disabled', 'class'],
            });
          }
        }
      }

      connectedCallback() {
        this.button = this.querySelector('.scroll-to-top-button');
        this.setupEventListeners();

        this._mainAtcBtn = document.getElementById('main_atc_button');
        if (!this._mainAtcBtn) return;

        this._atcObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                this.showButton();
              } else if (entry.isIntersecting) {
                this.hideButton();
              }
            });
          },
          { threshold: 0 },
        );

        this._atcObserver.observe(this._mainAtcBtn);
      }

      disconnectedCallback() {
        if (this._atcObserver) this._atcObserver.disconnect();
        if (this._btnObserver) this._btnObserver.disconnect();
      }

      _syncBtn() {
        if (!this._mainBtn || !this.sticky_btn) return;
        const span = this._mainBtn.querySelector('span');
        const stickySpan = this.sticky_btn.querySelector('span');
        if (span && stickySpan)
          stickySpan.textContent = span.textContent.trim();
        this.sticky_btn.disabled = this._mainBtn.disabled;
      }

      _syncLoading() {
        if (!this._mainBtn || !this.sticky_btn) return;
        const loading = this._mainBtn.classList.contains('loading');
        this.sticky_btn.classList.toggle('loading', loading);
        if (loading) {
          this.sticky_btn.setAttribute('aria-disabled', 'true');
        } else {
          this.sticky_btn.removeAttribute('aria-disabled');
        }
        if (this._spinner) this._spinner.classList.toggle('hidden', !loading);
      }

      setupVariantChangeListener(e) {
        const currentVariant = e.detail.currentVariant;
        this.title_el.innerText = currentVariant.name;
        this._syncBtn();
      }
    },
  );
}
